//设备配对
import Home from "@/views/equipment-pair/Home";
import EquipmentDetails from "@/views/equipment-pair/EquipmentDetails";
import Bind from "@/views/equipment-pair/Bind";

const routes = [
    {
        path: "/equipment-pair/home",
        name: "Home",
        meta: {
            title: "titles.equipmentPair"
        },
        component: Home
    },
    {
        path: "/equipment-pair/equipment-details",
        name: "EquipmentDetails",
        meta: {
            title: "titles.gatewayControllerDetail"
        },
        component: EquipmentDetails
    },
    {
        path: "/qrcode/device/:seriCode/:deviceId",
        name: "bind",
        meta: {
            title: "titles.productGuidance"
        },
        component: Bind
    },

];
export default routes;
